import { render, staticRenderFns } from "./discountChart.vue?vue&type=template&id=0bbe6de8&scoped=true"
import script from "./discountChart.vue?vue&type=script&lang=js"
export * from "./discountChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe6de8",
  null
  
)

export default component.exports